import Repair from "./Repair";
import Oil from "./Oil"

export default {
  Repair,
  Oil
};
